import { type Column, EmptyState, Pill, Table } from "@/components/common";
import { useAuditLogs } from "@/hooks/useAuditLogs";
import type { AuditAction, AuditLog } from "@/types/audit";

const ACTION_TONE: Record<AuditAction, "ativa" | "diag" | "alerta"> = {
  create: "ativa",
  update: "diag",
  delete: "alerta",
};
const ACTION_LABEL: Record<AuditAction, string> = {
  create: "Criou",
  update: "Editou",
  delete: "Excluiu",
};

function dateTime(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString("pt-BR");
}

export function AuditLogsPanel({ workspaceId }: { workspaceId: number }) {
  const { data: logs = [], isLoading } = useAuditLogs(workspaceId);

  const columns: Column<AuditLog>[] = [
    { id: "when", header: "Quando", cell: (l) => <span className="td-faded">{dateTime(l.created_at)}</span> },
    {
      id: "actor",
      header: "Ator",
      cell: (l) => (
        <span className="td-muted">{l.actor_user_id != null ? `Usuário #${l.actor_user_id}` : "Sistema"}</span>
      ),
    },
    {
      id: "action",
      header: "Ação",
      cell: (l) => <Pill tone={ACTION_TONE[l.action] ?? "pausada"}>{ACTION_LABEL[l.action] ?? l.action}</Pill>,
    },
    {
      id: "entity",
      header: "Entidade",
      cell: (l) => (
        <span className="cnpj">
          {l.entity_type} #{l.entity_id}
        </span>
      ),
    },
  ];

  return (
    <Table
      rows={logs}
      columns={columns}
      getKey={(l) => String(l.id)}
      empty={
        <EmptyState
          icon="file-text"
          size="lg"
          title={isLoading ? "Carregando…" : "Sem registros"}
          description={isLoading ? undefined : "As mutações no workspace aparecerão aqui."}
        />
      }
    />
  );
}
